<template>
  <div>
    <v-card flat class="rounded-0" color="light-grey">
      <v-list class="pa-0">
        <v-list-item
          v-for="item in items"
          :key="item.key"
        >
          <v-list-item-content class="mt-1 pt-2 pb-0" :style="'background-color: #FFEBEE;'">
            <v-row align="center" class="px-4">
              <v-col cols="2" class="py-0"><span style="font-weight: bold;">key</span></v-col>
              <v-col cols="4" align="center" class="py-0"><span color="primary" class="primary elevation-1 px-2 py-1 rounded" style="color: white;font-size: 14px;">{{ item.key }}</span></v-col>
              <v-col cols="6" class="py-0"></v-col>
              <v-col cols="2" class="pb-0"><span style="font-weight: bold;">counter</span></v-col>
              <v-col cols="10" align="end" class="pb-1">
                <v-row>
                  <div v-for="(v, index) in 16" :key="index">
                    <v-col v-if="index > 0" cols="auto" class="pa-0" style="width: 40px;">
                      <span class="px-0 py-1 rounded" style="font-size: 14px;">{{ index }}</span>
                    </v-col>
                  </div>
                </v-row>
                <v-row>
                  <div v-for="(v, index) in item.counters" :key="index">
                    <v-col v-if="index > 0" cols="auto" class="pa-0" style="width: 40px;">
                      <span class="elevation-1 px-0 ml-1 py-1 rounded overflow-text-hidden" :style="(index < 8 && v > 1 ? 'background-color: red; color: white;' : 'background-color: white;') + 'font-size: 14px;'">{{ v }}</span>
                    </v-col>
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" class="px-4" :style="'background-color: white;'">
              <v-col v-for="(sts) in item.stats" :key="sts.createdAt" cols="12" class="py-0">
                <v-row>
                  <v-col cols="1" class="pa-1"><span style="font-size: 14px;">{{ sts.id }}</span></v-col>
                  <v-col cols="1" class="pa-1"><span style="font-size: 14px;">{{ sts.status }}</span></v-col>
                  <v-col cols="1" class="pa-1"><span style="font-size: 14px;">{{ sts.yyyy }}</span></v-col>
                  <v-col cols="1" class="pa-1"><span style="font-size: 14px;">{{ sts.mm }}</span></v-col>
                  <v-col cols="8" class="pa-1"></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>

    <div>
      <loading-with-status :loading="loading" :status="status"></loading-with-status>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    items () {
      var temp = []
      var keys = Object.keys(this.errors[this.school])
      for (var i in keys) {
        var index = this.slists.findIndex(s => s.school.key === this.school)
        var status = JSON.parse(JSON.stringify(this.slists[index].status[keys[i]]))
        status.sort(function (a, b) {
          if (a.id > b.id) return 1
          if (a.id < b.id) return -1
          return 0
        })
        var data = {
          key: keys[i],
          stats: status,
          counters: this.slists[index].counters[keys[i]]
        }
        temp.push(JSON.parse(JSON.stringify(data)))
      }
      return temp
    }
  },
  props: ['slists', 'school', 'errors'],
  data () {
    return {
      loading: false,
      status: ''
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss.SSS')
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

</style>
